export const R = {
	"title": "Choose who you are booking for",
	"subtitle": "When you choose a child, it will be added to your profile and the booking will continue.",
	"buttonCreateManually": "Add manually",
	"buttonInviteManually": "Invite manually"
}